import {baseBackendUrl} from "../shared/constants";

export async function getLogs() {
    const token = localStorage.getItem("token");
    const response = await fetch(`${baseBackendUrl}/logs/view`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    if (!response.ok) throw new Error("Ошибка загрузки логов");
    const data = await response.json();
    const reversedLogs = data.logs.split("\n").reverse().join("\n");
    return reversedLogs;
}